/**
 * Book-need view-id conventions shared by marketStore and the views that
 * declare needs. Its own module (not marketStore) so a test that mocks the
 * store still sees the constant.
 *
 * `<viewId>|cells`: the part of a NON-board view's books it draws only as
 * cells (price / liquidity / resting), which a transport may serve at a
 * cadence. The bare id keeps the per-delta set: the ticket, the selected
 * line, an open ladder. Introduced 2026-10-09 for Game Detail (bugfix 261008:
 * every alt-line rung was a per-delta ladder need, 99–133 books on one tab).
 */
export const CELL_BOOK_VIEW_SUFFIX = '|cells';
